import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useSelector } from "react-redux";

import { headerWrapperStyles, headerStyles, titleStyles, logoStyles, headerButtonStyles } from "./styles/Header.styles";
import { AppState } from "../store/definitions";


export const Header = ({ conversationState, conversationSid }: { conversationState?: boolean; conversationSid?: string }) => {

    const { companyLogoUrl } = useSelector((state: AppState) => state.config);

    // Properly flatten logo styles
    const headerNoLogoStyles = {
        height: logoStyles.height,
        ...logoStyles.style,
        display: "flex",
        color: 'white',
        alignItems: "center",
        justifyContent: "center"
    };

    const headerTextStyle = companyLogoUrl ? titleStyles.style : headerNoLogoStyles;

    const handleEndChat = async () => {
        if (conversationState) {
            const url = process.env.REACT_APP_END_CONVERSATION_URL;

            try {
                const response = await fetch(`${url}?conversationSid=${conversationSid}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`Request failed with status: ${response.status}`);
                }

                const data = await response.json();
                console.log('Response data:', data);
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    return (
        <Box
            backgroundImage={headerWrapperStyles.backgroundImage}
            backgroundRepeat={headerWrapperStyles.backgroundRepeat}
            backgroundSize={headerWrapperStyles.backgroundSize}
            backgroundPosition={headerWrapperStyles.backgroundPosition}
        >
            <Box
                padding={headerStyles.padding}
                style={headerStyles.style}
                alignItems="center"
                justifyContent={companyLogoUrl ? headerStyles.justifyContent : "center"}
            >
                <Text
                    as="h1"
                    textAlign="center"
                    fontSize={titleStyles.fontSize}
                    fontWeight={titleStyles.fontWeight}
                    style={headerTextStyle}
                >
                    Television Support Live Chat
                </Text>

                {companyLogoUrl && (
                    <img
                        className="velaro-header-logo"
                        src={companyLogoUrl}
                        alt=""
                        role="presentation"
                        width={logoStyles.width}
                        height={logoStyles.height}
                        style={logoStyles.style}
                    />
                )}

                {conversationState && (
                    <button
                        data-test="end-chat-button"
                        style={headerButtonStyles}
                        type="submit"
                        onClick={handleEndChat}
                        title="End Chat"
                    >
                        &#x2715;
                    </button>
                )}
            </Box>
        </Box>
    );
};